import Vue from 'vue';
import VueGtag from 'vue-gtag';
import VueSmoothScroll from 'vue2-smooth-scroll'
import App from './App.vue';
import router from './router';

Vue.use(VueGtag, {
    config: {id: 'UA-175570245-1'}
}, router);

Vue.use(VueSmoothScroll);

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
